// extracted by mini-css-extract-plugin
export default {"banner":"DemoBanner_banner__ZO7Fo","banner-in":"DemoBanner_banner-in__dobJI","fading_out":"DemoBanner_fading_out__Kz49F"};